module.exports = __webpack_public_path__ + "static/14-7ee2dd0bdafed31c36af021db391dba7.jpeg";